import React, { PureComponent } from 'react';
import { getTalkTime } from '../../utils/utils'


class LoadingBalloon extends PureComponent {

    render() {
        const inlineStyle={
            width : "80px"
        }
        return (
            <div className="bubble_area">
            <span className="bot_box">
                <span className="ico_comm ico_chatbot"></span>
            </span>
            <div className="bubble_box">
            <div className="bubble_unit" style={inlineStyle}>
                <div className="three-balls">
                    <div className="ball ball1"></div>
                    <div className="ball ball2"></div>
                    <div className="ball ball3"></div>
                </div>
            </div>
            </div>
            <span className="bubble_time">{getTalkTime()}</span>
            </div>
        );
    }
};

export default LoadingBalloon;

/*
<div className="time">{getTalkTime()}</div>
*/